<template>
  <div v-if="$store.state.user" class="monPass compteTab">
    <div class="warning" v-if="$route.query.perr == 1">
      <strong class="red">Une erreur a eu lieu ou votre paiement n'a pas été accepté.</strong> Veuillez refaire un essai
      ou
      <router-link class="pinkLink" :to="{ name: 'Contact', params: { sujet: 'Paiement refusé' } }"
        >nous contacter en cliquant ici </router-link
      >si le problème persiste.
    </div>
    <h2>Mon Pass en cours</h2>
    <div class="form" v-if="sale">
      <div class="label">
        Type de Pass :
      </div>
      <div class="value" v-html="passName()"></div>
      <div v-if="hasPass" class="label">
        Référence du paiement :
      </div>
      <div v-if="hasPass" class="value">
        <span>{{ sale.ref }}</span>
      </div>
      <div v-if="hasPass" class="label">
        Date d'expiration :
      </div>
      <div v-if="hasPass" class="value">
        {{ expiration() }}
      </div>
      <div v-if="hasPass" class="label">
        Prélèvement automatique :
      </div>
      <div v-if="hasPass" class="value">
        {{ prelev }}
      </div>
      <div v-if="hasPrelev" class="label">
        Prochain prélèvement le :
      </div>
      <div v-if="hasPrelev" class="value">
        {{ expiration() }} ({{ priceString(sale.product.price + serenityPrice(sale), sale.product.currency) }})
      </div>
    </div>
    <div v-if="hasPass && !mayPrelev">
      <h2>Renouveler Mon Pass</h2>
      <p>
        Afin d'éviter toute période d'interruption, vous pouvez dès maintenant prolonger votre Pass <ColoredName />. Il
        vous sera alors offert de choisir entre les quatre types de Pass <ColoredName /> existants. Lorsque vous
        prolongez votre Pass, la durée correspondant à votre nouveau Pass est automatiquement créditée à votre Pass
        actuel, aucun jour n'est perdu si vous effectuez votre prolongation à l'avance.
      </p>
      <router-link :to="{ name: 'Pass' }" class="bouton">Renouveler mon Pass</router-link>
    </div>
    <div v-if="!hasPass">
      <h2>Découvrir le Pass <ColoredName /></h2>
      <p>
        Le Pass <ColoredName /> vous permet de lire les messages que vous avez reçus sur le site ainsi que de permettre
        à tous vos correspondants de lire gratuitement les messages que vous leur envoyez. Le Pass vous permet également
        de naviguer sans publicité.
      </p>
      <router-link :to="{ name: 'Pass' }" class="bouton">Découvrir le Pass&nbsp;<ColoredName /></router-link>
    </div>

    <div v-if="hasPass">
      <div>
        <input @change="renewChanged" type="checkbox" id="renouvPass" v-model="renewPass" />
        <label for="renouvPass">Renouveler mon Pass à échéance.</label>
      </div>
    </div>

    <h2 v-if="payments && payments.length != 0">Historique des paiements</h2>
    <div v-if="payments && payments.length != 0" class="histoContainer">
      <table v-if="payments && payments.length != 0" class="histo">
        <tr>
          <th>Référence</th>
          <th>Date</th>
          <th class="desc">Description</th>
          <th class="moy">Moyen de paiement</th>
          <th>Montant</th>
          <th class="status">Etat</th>
        </tr>
        <tr v-for="pay in payments" :key="pay.id">
          <td>{{ pay.ref }}</td>
          <td>{{ format(pay.date) }}</td>
          <td class="desc">{{ pay.product.name }}</td>
          <td class="moy">{{ method(pay) }}</td>
          <td>{{ priceString(pay.price, pay.product.currency) }}</td>
          <td class="status"><span v-html="paymentStatus(pay.status)"></span></td>
        </tr>
      </table>
    </div>

    <modal v-if="showCancelPassWindow">
      <template v-slot:header><b>Annuler le renouvellement de mon Pass</b></template>
      <template v-slot:body>
        <div id="fenetreRaison">
          <p>
            Pourriez-vous nous renseigner sur la raison pour laquelle vous souhaitez annuler la reconduction automatique
            de votre Pass ?
          </p>

          <div v-for="reason of filteredReasons" :key="reason.id">
            <input v-model="selectedReason" :value="reason.id" type="radio" name="reasonRadio" /><label>{{
              reason.reason
            }}</label>
            <br />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="cancellationFooter">
          <a @click.prevent="cancelPass" class="bouton" href="#">Valider</a>
          <a @click.prevent="closeModal" class="bouton" href="#">Annuler</a>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { idyuGetPassName, idyuFormatDate, idyu_hasPass } from "@/assets/js/idyu/util.js";
import Modal from "@/components/util/Modal";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import ColoredName from "@/components/util/ColoredName";
import { idyuSalesStatus } from "@/assets/js/idyu/reference";

export default {
  name: "MonPass",
  components: { ColoredName, Modal },
  data() {
    return {
      sale: null,
      payments: null,
      showCancelPassWindow: false,
      renewPass: false,
      cancellationReasons: [],
      selectedReason: 6
    };
  },

  methods: {
    method(pay) {
      if (!pay.paymentMethod) {
        return "/";
      }
      return pay.paymentMethod.name;
    },

    async renewChanged(e) {
      if (this.renewPass) {
        try {
          await idyuJsonRpc("reactivateSubscription");
          this.pass.status = 11;
        } catch {
          e.preventDefault();
          await alert("Une erreur a eu lieu et votre abonnement n'a pas pu être réactivé.");
        }
      } else {
        this.showCancelPassWindow = true;
      }
    },

    closeModal() {
      this.showCancelPassWindow = false;
      this.renewPass = true;
    },

    serenityPrice(sale) {
      if (!this.pass) {
        return 0;
      }

      if (this.pass.permission != 3) {
        return 0;
      }
      if (sale.product.type == 2) {
        return 0;
      }
      if (sale.product.code == 0) {
        return 5;
      }
      return 3;
    },

    async cancelPass() {
      try {
        await idyuJsonRpc("cancelSubscription", this.selectedReason);
        this.pass.status = 12;
        this.showCancelPassWindow = false;
      } catch {
        await alert("Une erreur a eu lieu et votre abonnement n'a pas pu être annulé.");
        this.renewPass = true;
      }
    },

    init: async function() {
      if (this.pass.idSale) this.sale = await idyuJsonRpc("getMainSales");
      this.payments = await idyuJsonRpc("getAllPayments", this.$store.state.user.id);
    },

    passName: function() {
      return idyuGetPassName(this.$store);
    },

    expiration: function() {
      return idyuFormatDate(this.pass.expiration);
    },

    nextBilling: function() {
      return idyuFormatDate(this.pass.nextBilling);
    },

    priceString: function(amount, currency) {
      return ("" + Math.round(amount * 100) / 100).replace(".", ",") + " " + currency.replace("EUR", "€");
    },

    paymentStatus: function(status) {
      return idyuSalesStatus(status);
    },

    format: function(date) {
      return idyuFormatDate(date);
    }
  },

  async created() {
    this.renewPass = this.pass.status == 11;
    this.cancellationReasons = await idyuJsonRpc("getCancellationReasons");
  },

  computed: {
    filteredReasons() {
      return this.cancellationReasons.filter(elt => elt.id != 7);
    },

    mayPrelev() {
      return this.pass.status >= 11;
    },

    pass: function() {
      if (!this.$store.state.user) {
        return null;
      }
      return this.$store.state.user.pass;
    },

    prelev: function() {
      if (this.hasPrelev) return "En cours";
      if (this.pass.status == 12) return "Annulé";
      return "Désactivé";
    },

    hasPrelev: function() {
      return this.pass.status == 11;
    },

    hasPass: function() {
      return idyu_hasPass(this.pass.permission) && this.sale;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/compte.scss";

.form {
  .label {
    text-align: right;
  }

  .value {
    font-weight: bold;
  }
}

.histoContainer {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  width: max-content;
  border: $light_border;
  margin-top: 10px;
  width: 100%;
  max-width: 1000px;
}

.histo {
  width: 100%;
  border-collapse: collapse;
  td,
  th {
    border: $light_border;
    padding: 5px;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;
  }

  tr:first-child {
    td,
    th {
      border-top: none;
    }
  }

  tr:last-child {
    td,
    th {
      border-bottom: none;
    }
  }

  td:first-child,
  th:first-child {
    border-left: none;
  }

  td:last-child,
  th:last-child {
    border-right: none;
  }
}
.warning {
  padding: 10px;
  border: 1px #ccc solid;
  background-color: rgb(249, 253, 193);
}

.cancellationFooter {
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    margin-top: 10px;
    margin-left: 5px;
    margin-right: 5px;
    text-align: center;
  }
}
@media screen and (max-width: 890px) {
  .histo {
    th {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}

@media screen and (max-width: 840px) {
  .histo {
    .moy {
      display: none;
    }
  }
}

@media screen and (max-width: 675px) {
  .histo {
    .desc {
      display: none;
    }
  }
}

@media screen and (max-width: 390px) {
  .histo {
    .status {
      display: none;
    }
  }
}
</style>
